import { render, staticRenderFns } from "./numberbox.vue?vue&type=template&id=3e9f538b&scoped=true&"
import script from "./numberbox.vue?vue&type=script&lang=ts&"
export * from "./numberbox.vue?vue&type=script&lang=ts&"
import style0 from "./numberbox.vue?vue&type=style&index=0&id=3e9f538b&lang=scss&scoped=true&"
import style1 from "./numberbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f538b",
  null
  
)

export default component.exports